import { ApiPublicInstance } from "@/services/api/api.public";
import ApiInstance from "@/services/api/api.utils";
import { CertificateMethods } from "@/services/constants/global";
import {
  parsedApplicantModel,
  parsedApplicantResumeModel,
} from "@/services/models/applicant";
import { parseJobRecruitmentModel } from "@/services/models/job";
import { formatDate } from "@/services/utils/formatter";

/**
 * Corporate information
 */

export const getCorporateDetail = async (corporate) => {
  const res = await ApiInstance.get(`/corporate/${corporate}`);
  return res;
};

export const getCorporateDetailPublic = async (id) => {
  const res = await ApiPublicInstance.get(`/corporate/${id}`);
  return {
    ...res,
    dateOfEstablishment: formatDate(res.dateOfEstablishment),
  };
};

export const getCorporateVideoInterviews = async (params) => {
  const res = await ApiInstance.get(`/interviews/new`, { params });
  return res;
};

export const postCorporateUpdateInfo = async (payload) => {
  const res = await ApiInstance.post("/corporate", payload, {
    "Content-Type": "multipart/form-data",
  });
  return res;
};

export const recoverUsername = async ({
  type = "",
  companyName = "",
  registrationNumber = "",
  phone = "",
  email = "",
}) => {
  const payload = { type, companyName, registrationNumber };
  if (payload.type === CertificateMethods.PHONE) {
    payload.phone = phone;
  }
  if (payload.type === CertificateMethods.EMAIL) {
    payload.email = email;
  }
  const res = await ApiInstance.post("corporate/recover-username", payload);
  return res;
};

export const resetPassword = async ({
  type = "",
  companyName = "",
  registrationNumber = "",
  phone = "",
  email = "",
}) => {
  const payload = { type, companyName, registrationNumber };
  if (payload.type === CertificateMethods.PHONE) {
    payload.phone = phone;
  }
  if (payload.type === CertificateMethods.EMAIL) {
    payload.email = email;
  }
  const res = await ApiInstance.post("corporate/reset-password", payload);
  return res;
};

export const getCorporateExistRegistrationNumber = async (
  registrationNumber
) => {
  const queryParams = new URLSearchParams();
  queryParams.append("registrationNumber", registrationNumber);
  const res = await ApiInstance.get(
    `/auth/users/corporate/check-exist-registration-number?${queryParams.toString()}`
  );
  return res;
};

export const getCorporateExistPhoneNumber = async (id, phoneNumber) => {
  const queryParams = new URLSearchParams();
  queryParams.append("id", id);
  queryParams.append("phoneNumber", phoneNumber);
  const res = await ApiInstance.get(
    `/auth/users/corporate/check-exist-phone-number?${queryParams.toString()}`
  );
  return res;
};

/**
 * Job Recruitment
 */

export const postJobRecruitmentRegisterForm = async (payload) => {
  const res = await ApiInstance.post("/jobs", payload, {
    "Content-Type": "multipart/form-data",
  });
  return res;
};

export const postUpdateJobRecruitment = async (payload) => {
  const res = await ApiInstance.post("/jobs/update", payload, {
    "Content-Type": "multipart/form-data",
  });
  return res;
};

export const getCorporateList = async (params) => {
  const res = await ApiInstance.get("/corporate", { params });
  return res;
};

export const getListOfJobRecruitment = async (params) => {
  const res = await ApiInstance.get("/corporate/jobs", { params });
  return {
    ...res,
    docs: res.docs.map((item) => parseJobRecruitmentModel(item)),
  };
};

/**
 * Member Management
 */

export const putMemberManagement = async (payload) => {
  const res = await ApiInstance.put("/users/update/corporate", payload);
  return res;
};

/**
 * Applicant
 */

export const getListOfApplicant = async (params) => {
  const res = await ApiInstance.get("/applicants/corporates", {
    params: { ...params, type: "JOB" },
  });
  return {
    ...res,
    docs: res.docs.map((item) => parsedApplicantModel(item)),
  };
};

export const getCorporateApplicantDetail = async (id) => {
  const res = await ApiInstance.get(`/applicants/${id}`);
  return {
    ...res,
    resume: parsedApplicantResumeModel(res.resume),
  };
};

export const patchUpdateApplicantStatus = async ({ id, status }) => {
  const res = await ApiInstance.patch(`/applicants/${id}`, {
    status,
  });
  return res;
};

export const getMyCorporateDetail = async () => {
  const res = await ApiInstance.get(`/corporate/detail`);
  return res;
};
